import * as action from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchBalanceHoursSuccess = balanceHours => ({
  type: action.FETCH_BALANCE_HOURS_SUCCESS,
  balanceHours,
});

export const fetchBankHoursSuccess = bankHours => ({
  type: action.FETCH_BANK_HOURS_SUCCESS,
  bankHours,
});

export const fetchBankHours = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/balanceHours/update/${id}`)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchBankHoursSuccess(response.data.detailed));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};


export const createBankHourSuccess = bankHour => ({
  type: action.CREATE_BANK_HOUR_SUCCESS,
  bankHour,
});

export const createBankHour = data => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/extrasHours/lot', data)
    .then((response) => {
      dispatch(createBankHourSuccess(response.data[0]));
      dispatch(setLoading(false));
      dispatch(setMessage('Hora baixada com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const updateBankHourSuccess = bankHour => ({
  type: action.UPDATE_BANK_HOUR_SUCCESS,
  bankHour,
});

export const updateBankHour = data => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/balanceHours/balance', data)
    .then(() => {
      dispatch(updateBankHourSuccess(data));
      dispatch(setLoading(false));
      dispatch(setMessage('Hora baixada atualizada com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const fetchBalanceHours = () => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get('/balanceHours/balance')
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchBalanceHoursSuccess(response.data));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const updateBalanceHourSuccess = currentBalance => ({
  type: action.UPDATE_BALANCE_HOUR_SUCCESS,
  currentBalance,
});

export const updateBalanceHour = id => (dispatch) => {
  dispatch({ type: action.UPDATE_BALANCE_HOUR_START });
  axios
    .get(`/balanceHours/update/${id}`)
    .then((response) => {
      dispatch({ type: action.UPDATE_BALANCE_HOUR_END });
      dispatch(updateBalanceHourSuccess(response.data.balance.balance));
    })
    .catch((error) => {
      dispatch({ type: action.UPDATE_BALANCE_HOUR_END });
      dispatch(setMessage(error));
    });
};

export const fetchExtraHoursSuccess = extraHours => ({
  type: action.FETCH_EXTRA_HOURS_SUCCESS,
  extraHours,
});

export const fetchExtraHours = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/extrasHours/${id}`)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(fetchExtraHoursSuccess(response.data));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const createExtraHourSuccess = extraHour => ({
  type: action.CREATE_EXTRA_HOUR_SUCCESS,
  extraHour,
});

export const createExtraHour = data => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/extrasHours/lot', data)
    .then((response) => {
      dispatch(createExtraHourSuccess(response.data[0]));
      dispatch(setLoading(false));
      dispatch(setMessage('Hora baixada com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const updateExtraHourSuccess = extraHour => ({
  type: action.UPDATE_EXTRA_HOUR_SUCCESS,
  extraHour,
});

export const updateExtraHour = data => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/extrasHours', data)
    .then(() => {
      dispatch(updateExtraHourSuccess(data));
      dispatch(setLoading(false));
      dispatch(setMessage('Hora baixada atualizada com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const deleteExtraHourSuccess = (id, amount) => ({
  type: action.DELETE_EXTRA_HOUR_SUCCESS,
  id,
  amount,
});

export const deleteExtraHour = (id, amount) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/extrasHours/${id}`)
    .then(() => {
      dispatch(setLoading(false));
      dispatch(deleteExtraHourSuccess(id, amount));
      dispatch(setMessage('Hora baixada excluída com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};
